import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-supplier-discounts',
  standalone: false,
  templateUrl: './admin-supplier-discounts.component.html',
  styleUrl: './admin-supplier-discounts.component.scss'
})
export class AdminSupplierDiscountsComponent {

}
